<template>
  <v-dialog persistent :value="visible" @input="cambiarVisibilidad" scrollable max-width="1000px">
    <v-card>
      <v-card-title>Detalle Cartera: {{ empleado.nombreCompleto }} </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <slot />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text @click="cerrar">Salir</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalCartera',

  props: {
    visible: { type: Boolean, default: false },
    empleado: { type: Object, default: () => ({}) },
  },

  methods: {
    cambiarVisibilidad(dialogoVisible) {
      if (!dialogoVisible) this.cerrar();
    },

    cerrar() {
      this.$emit('close');
    },
  },
};
</script>
